module.exports = __webpack_public_path__ + "img/google_sync_explanation.8e2de4bd.png";